import { inject, Injectable } from '@angular/core';
import { LegalDocumentsService } from './legal-documents.service';
import { ApiLegalDocumentsCacheService } from './api-legal-documents-cache.service';
import { map } from 'rxjs/operators';

@Injectable()
export class LegalDocumentLinksService {
  protected readonly legalDocumentsService = inject(LegalDocumentsService);
  protected readonly apiLegalDocumentsCacheService = inject(ApiLegalDocumentsCacheService);

  public readonly privacyPolicyHref = this.legalDocumentsService.getPrivacyPolicyHref();
  public readonly cookiePolicyHref = this.legalDocumentsService.getCookiePolicyHref();

  public readonly hasCookiePolicy$ = this.apiLegalDocumentsCacheService.getDocuments()
    .pipe(
      map(({ cookiePolicy }) => !!(cookiePolicy?.text || cookiePolicy?.url)),
    );
}
